import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  page: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 0,
    padding: "16px 20px 24px",
    boxSizing: "border-box",
    gap: 12,
    // the device card above can take the whole viewport; scroll instead of starving the table
    overflowY: "auto"
  },

  toolbar: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap"
  },

  toolbarTitle: {
    fontSize: "15px",
    fontWeight: 500,
    color: "#4b1c46"
  },

  toolbarSpacer: {
    flex: 1
  },

  // same look as the sync page's toolbar buttons
  actionButton: {
    textTransform: "none",
    fontWeight: 600
  },

  tabsBar: {
    minHeight: 40,
    "& .MuiTab-root": {
      minHeight: 40,
      textTransform: "none",
      fontWeight: 600
    }
  },

  tablePaper: {
    display: "flex",
    flexDirection: "column",
    // a full screen of table below the tabs; rows scroll inside it under a sticky header
    flex: "0 0 auto",
    height: "calc(100vh - 180px)",
    minHeight: 360,
    borderRadius: 4,
    border: "1px solid #e5e2e5",
    overflow: "hidden"
  },

  tableContainer: {
    position: "relative",
    flex: 1,
    minHeight: 0,
    overflow: "auto"
  },

  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.6)"
  },

  headCell: {
    backgroundColor: "#f6f6f7",
    color: "#4b1c46",
    fontSize: "12px",
    fontWeight: 500,
    letterSpacing: "0.4px",
    whiteSpace: "nowrap"
  },

  row: {
    "&:hover": {
      backgroundColor: "#fbfafb"
    }
  },

  cell: {
    fontSize: "13px",
    color: "#333",
    whiteSpace: "nowrap"
  },

  numCell: {
    fontSize: "13px",
    color: "#333",
    whiteSpace: "nowrap",
    fontVariantNumeric: "tabular-nums"
  },

  mono: {
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: "12.5px"
  },

  okIcon: {
    fontSize: "18px",
    color: "#3f7d3f",
    verticalAlign: "middle",
    marginRight: 4
  },

  failIcon: {
    fontSize: "18px",
    color: "#d32f2f",
    verticalAlign: "middle",
    marginRight: 4
  },

  warnIcon: {
    fontSize: "18px",
    color: "#b26a00",
    verticalAlign: "middle"
  },

  viewIcon: {
    fontSize: "19px",
    color: "#736973"
  },

  emptyCell: {
    borderBottom: "none",
    padding: "48px 16px"
  },

  emptyText: {
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "italic",
    color: "#8f8a8f"
  },

  empty: {
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "italic",
    color: "#8f8a8f",
    marginTop: 48
  },

  pagination: {
    borderTop: "1px solid #e5e2e5",
    flexShrink: 0
  },

  summaryPaper: {
    border: "1px solid #e5e2e5",
    borderRadius: 4,
    padding: "12px 16px"
  },

  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))",
    gap: "8px 20px"
  },

  summaryLabel: {
    fontSize: "11px",
    fontWeight: 500,
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    color: "#8f8a8f"
  },

  summaryValue: {
    fontSize: "13px",
    color: "#333",
    marginTop: 2
  },

  sectionTitle: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#4b1c46",
    margin: "8px 0 4px"
  },

  groupPaper: {
    border: "1px solid #e5e2e5",
    borderRadius: 4,
    overflow: "hidden"
  },

  // flows with the page scroll; the device card and terminal above can fill the viewport
  detailScroll: {
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "column",
    gap: 12
  },

  infoBlock: {
    fontSize: "13.5px",
    color: "#333",
    padding: "14px 16px",
    border: "1px dashed #c9c3c9",
    borderRadius: 4,
    backgroundColor: "#fbfafb"
  }
}));

export default useStyles;
